import React from "react";

const BookContent = () => {
  const chapters = [
    "O Verbo que se Fez Carne: O Prólogo e a Genealogia de Jesus",
    "O Anúncio do Salvador: A Promessa a Maria e José",
    "O Nascimento do Rei: Jesus em Belém",
    "A Infância de Jesus: O Templo e o Crescimento do Menino",
    "O Batismo e a Identidade Divina: A Voz do Pai",
    "A Provação no Deserto: A Vitória Sobre a Tentação",
    "O Chamado aos Pescadores: Venham e Sigam-me",
    "O Primeiro Milagre em Caná: A Água que Se Transformou em Vinho",
    "Nicodemos e o Novo Nascimento: O Segredo da Vida Eterna",
    "A Mulher Samaritana: A Água Viva para Todos"
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-16">
          No livro "A Vida de Jesus" você vai descobrir…
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Column - Benefits */}
          <div className="space-y-8">
            <div className="flex items-start space-x-4">
              <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
                <div className="w-6 h-6 bg-white rounded-full"></div>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-2">Como caminhar ao lado de Jesus</h3>
                <p className="text-gray-700">como se fosse um de Seus discípulos, testemunhando cada milagre em primeira pessoa;</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
                <div className="w-6 h-6 bg-white rounded-full"></div>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-2">Como descobrir a prosperidade eterna</h3>
                <p className="text-gray-700">que vai além do material e transforma sua vida espiritual para sempre;</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
                <div className="w-6 h-6 bg-white rounded-full"></div>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-2">A narrativa harmoniosa dos quatro evangelhos</h3>
                <p className="text-gray-700">unificada em uma jornada contínua e transformadora;</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
                <div className="w-6 h-6 bg-white rounded-full"></div>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-2">Como aplicar os princípios do Reino</h3>
                <p className="text-gray-700">através de tarefas práticas e perguntas reflexivas em cada capítulo;</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
                <div className="w-6 h-6 bg-white rounded-full"></div>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-2">Como viver as "obras maiores"</h3>
                <p className="text-gray-700">prometidas por Jesus através do poder do Espírito Santo hoje;</p>
              </div>
            </div>
          </div>

          {/* Right Column - More Benefits */}
          <div className="space-y-8">
            <div className="flex items-start space-x-4">
              <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
                <div className="w-6 h-6 bg-white rounded-full"></div>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-2">A transformação do coração</h3>
                <p className="text-gray-700">que começa agora e continua para a eternidade;</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
                <div className="w-6 h-6 bg-white rounded-full"></div>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-2">Como experimentar milagres</h3>
                <p className="text-gray-700">e ver o poder de Deus operando em sua vida diária;</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
                <div className="w-6 h-6 bg-white rounded-full"></div>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-2">O poder do perdão e da graça</h3>
                <p className="text-gray-700">que Jesus oferece para transformar relacionamentos e cura interior;</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
                <div className="w-6 h-6 bg-white rounded-full"></div>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-2">Como viver no sobrenatural</h3>
                <p className="text-gray-700">rompendo barreiras de medo e dúvida através da fé;</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="bg-red-600 p-2 rounded-full flex-shrink-0">
                <div className="w-6 h-6 bg-white rounded-full"></div>
              </div>
              <div>
                <h3 className="font-bold text-lg mb-2">Seu chamado para trazer o Reino</h3>
                <p className="text-gray-700">de Deus à Terra através de sua vida transformada.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">E muito, muito mais!</h3>
          
          {/* Sample Chapters */}
          <div className="bg-gray-50 rounded-xl p-8">
            <h4 className="text-xl font-bold text-gray-900 mb-6">Alguns capítulos inclusos:</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
              {chapters.map((chapter, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <span className="text-red-600 font-bold">{String(index + 1).padStart(2, '0')}.</span>
                  <span className="text-gray-700">{chapter}</span>
                </div>
              ))}
            </div>
            <p className="text-gray-600 mt-6">... e mais 31 capítulos transformadores!</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookContent;